<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm copy</v-card-title>
    <v-card-text>Are you sure you want to copy the Hosts to the Bookings ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="copyHsctToHoct">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huis_encrid: null,
      hsct: {}
    }
  },
  methods: {
    open(huis_encrid) {
      this.huis_encrid = huis_encrid;
      this.$emit("showSnackbar");
      this.dialog = true;
      /*
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hsct/getHsct.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsct"
          },
          getHsct: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsct = res.data.getHsct;
          }
        })
        .finally(() => {
          this.loading = false;
        });
       */ 
    },
    copyHsctToHoct() { 
      this.$axios
        .post("ares/json/ares/huis/hsct/copyHsctToHoct.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "copyHsctToHoct"
          },
          copyHsctToHoct: {
            huis_encrid: this.huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            //  if (res.data.copyHsctToHoct.color == "success") { 
            //     setTimeout(() => { this.$router.reload('/huis/onHuis/' + res.data.copyHsctToHoct.huis_encrid);  }, 2000);      
            //  }   
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.copyHsctToHoct.text,
              color: res.data.copyHsctToHoct.color
            });
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    },
  }
}
</script>

